// src/components/common/ThemeToggle.tsx
import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

interface Props {
  className?: string;
  variant?: 'default' | 'onPrimary'; // onPrimary = white icon for colored header bg
}

export const ThemeToggle: React.FC<Props> = ({ className = '', variant = 'default' }) => {
  const { isDarkMode, toggleTheme } = useTheme();

  if (variant === 'onPrimary') {
    return (
      <button
        onClick={toggleTheme}
        className={`w-9 h-9 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 transition-colors ${className}`}
        aria-label="Toggle theme"
        title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      >
        {isDarkMode
          ? <Sun size={18} className="text-white" />
          : <Moon size={18} className="text-white" />
        }
      </button>
    );
  }

  return (
    <button
      onClick={toggleTheme}
      className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors ${
        isDarkMode
          ? 'bg-dark-card text-yellow-400 hover:bg-dark-border'
          : 'bg-light-card text-light-subtle hover:bg-light-border'
      } ${className}`}
      aria-label="Toggle theme"
      title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
    >
      {isDarkMode ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
};
